module.exports = __webpack_public_path__ + "assets/img/29_281_big.5fc95714.jpg";